import { useStoreState } from 'providers/StoreStateContext';
import { TCardView } from 'store/view';

export const useListViewById = (id: string, defaultView: TCardView = 'list') => {
  const { viewById, setViewById } = useStoreState();

  const view = viewById[id] ?? defaultView;

  const setView = (nextView: TCardView) => {
    setViewById(id, nextView);
  };

  const toggleView = () => {
    setViewById(id, view === 'grid' ? 'list' : 'grid');
  };

  return {
    view,
    setView,
    toggleView,
  };
};
